import { bool, func, node, object, oneOf } from 'prop-types'
import { Component, Children, cloneElement } from 'react'
import { TrackedUnmanagedModal } from './unmanaged'

class Modal extends Component {
  static propTypes = {
    children: node,
    injectChildProps: bool,
    onClose: func,
    emotionStyleOverrides: object,
    shouldConfirmExit: bool,
    theme: oneOf(['light', 'dark']),
    visible: bool,
  }

  static defaultProps = {
    injectChildProps: true,
    theme: 'dark',
  }

  constructor(props) {
    super(props)
    this.state = {
      displayExitConfirmation: false,
    }
  }

  attemptExit = () => {
    if (this.props.shouldConfirmExit) {
      this.toggleExitConfirmation()
    } else {
      this.closeModal()
    }
  }

  closeModal = (e, trackingFn) => {
    const callback = () => this.props.onClose(e, trackingFn)
    this.setState({}, callback)
  }

  toggleExitConfirmation = () => {
    this.setState((prevState) => ({
      displayExitConfirmation: !prevState.displayExitConfirmation,
    }))
  }

  cloneChildren = () =>
    Children.map(this.props.children, (child) => {
      if (!child) return null
      const injectables = this.props.injectChildProps
        ? { onCloseFromModal: this.attemptExit }
        : {}
      return cloneElement(child, injectables)
    })

  render() {
    return (
      <TrackedUnmanagedModal
        {...this.props}
        visible={this.props.visible}
        onClose={this.closeModal}
        onCancelExit={this.toggleExitConfirmation}
        onDisplayConfirmation={this.attemptExit}
        displayExitConfirmation={this.state.displayExitConfirmation}
      >
        {this.cloneChildren()}
      </TrackedUnmanagedModal>
    )
  }
}

export default Modal
